/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "9984dbb3a87be1953dc74419a610ff39cbcad9c9";
